import { ListWithImage } from '../../../components/ListWithImage/ListWithImage';

export const InformationList = ({ className }) => {
    const list = [
        'Vi sender alle produktene direkte hjem til kjøperne',
        'Forventet leveringstid er 5 - 12 dager fra salgsdato',
        'Frakt er inkludert i prisen',
    ];

    return (
        <ListWithImage
            className={className}
            informationList={list}
            imageSrc={'gave-sende-hjem-dugnad.png'}
            imageAlt={'Illustrasjon av en pakke som har en pil som peker mot et familiehus'}
        />
    );
};
